// extracted by mini-css-extract-plugin
module.exports = {"homePage":"styles-module--homePage--2YKkU"};